'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { NotificationTargetTabs } from '../-components/NotificationTargetTabs';
import { NotificationRulesTable } from './-components/NotificationRulesTable';
export const Route = createFileRoute('/_staff/settings/notification-and-response/_layout/notification-rules/')({
  component: NotificationRules
});
function NotificationRules() {
  return <NotificationTargetTabs>
      <NotificationRulesTable />
    </NotificationTargetTabs>;
}